export default {"src":"/_next/static/media/buyer.c3fffffe.svg","height":31,"width":32};